/**
 * Identity Server Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AuthApiCredentialType = 'Password' | 'Passcode' | 'StaticCode' | 'Push' | 'HardwareToken' | 'Yubikey';

export const AuthApiCredentialType = {
    Password: 'Password' as AuthApiCredentialType,
    Passcode: 'Passcode' as AuthApiCredentialType,
    StaticCode: 'StaticCode' as AuthApiCredentialType,
    Push: 'Push' as AuthApiCredentialType,
    HardwareToken: 'HardwareToken' as AuthApiCredentialType,
    Yubikey: 'Yubikey' as AuthApiCredentialType
};

